<div class="container p-0 w-[500px]" [formGroup]="form" *ngIf="form">
  <mat-dialog-content>
    <div class="modal-dialog my-0">
      <div class="modal-content">
        <ng-container *ngIf="levelMode.ADD === mode; else edit">
          <div *ngIf="!parentLevel; else otherLevel" class="text-center">
            <h4 class="text-2xl">Add Level</h4>
            <div class="pb-2">Please enter a name for this level:</div>
          </div>
          <ng-template #otherLevel class="text-center">
            <h4 class="text-2xl text-center">Add Child</h4>
            <div class="ml-[10%] mr-[10%] text-center">
              You are about to add a level under {{ parentLevel.name }}. Please
              enter a name for this level
            </div>
          </ng-template>
          <div class="modal-body flex flex-col items-center pb-4">
            <mat-form-field appearance="outline">
              <input
                matInput
                type="text"
                id="name"
                name="name"
                required
                placeholder="Level Name"
                formControlName="name"
              />
              <mat-error>Required</mat-error>
            </mat-form-field>
          </div>
        </ng-container>
        <ng-template #edit>
          <ng-container *ngIf="levelMode.EDIT === mode; else delete">
            <div class="text-center">
              <h4 class="text-2xl">Edit Level</h4>
            </div>
            <div class="modal-body flex flex-col items-center">
              <mat-form-field appearance="outline">
                <input
                  matInput
                  type="text"
                  id="name"
                  name="name"
                  required
                  placeholder="Level Name"
                  formControlName="name"
                />
                <mat-error>Required</mat-error>
              </mat-form-field>
            </div>
          </ng-container>
          <ng-template #delete>
            <div class="text-center">
              <h4 class="text-2xl">Delete Level</h4>
            </div>
            <div class="modal-body">
              <ng-container>
                <h6 class="text-center mt-5 mb-10">
                  Are you sure you want to delete this level?
                </h6>
                <h6 class="mb-10 text-center">
                  NOTE: Once deleted this cannot be undone.
                  {{
                    data.facilitiesToReAssign?.length
                      ? "Any facilities not
                  reassigned will go back to being unassigned"
                      : ""
                  }}
                </h6>
              </ng-container>
              <thera-client-side-list
                class="block mb-10"
                *ngIf="data.facilitiesToReAssign?.length"
                [columnDefs]="colDefs"
                [rowData]="data.facilitiesToReAssign"
              >
              </thera-client-side-list>
            </div>
          </ng-template>
        </ng-template>
        <div class="block text-center">
          <div class="mb-5">
            <button mat-button (click)="onSave()">Save</button>
          </div>
          <div>
            <a (click)="dialogRef.close()"> Cancel </a>
          </div>
        </div>
      </div>
    </div>
  </mat-dialog-content>
</div>
